import { RepositoryFactory } from '@/api/RepositoryFactory';
import { ActionTree, Module } from 'vuex';
import CustomerRepository from '@/api/CustomerRepository';
import Customer from '@/models/Customer';
import { CustomerState } from '@/store/storeStateInterface';

const customerRepository: CustomerRepository = RepositoryFactory.get('customer');

const store: CustomerState = {
    allCustomers: []
};

const actions: ActionTree<any, any> = {
    getCustomerAction: async (_ctx, payload: { customerId: string }): Promise<Customer> => {
        const customerData = await customerRepository.getCustomer(payload.customerId);
        const customer = Customer.parseFromObject(customerData);
        return customer;
    },
    getAllCustomersAction: async ({ commit }): Promise<Customer[]> => {
        const customerData = await customerRepository.getAllCustomers();

        const customers = Customer.parseFromArray(customerData) as Customer[];
        commit('saveAllCustomers', { customers });
        return customers;
    },
    createCustomerAction: async (_ctx, payload: { customer: Customer }): Promise<Customer> => {
        const customerData = await customerRepository.createCustomer(payload.customer);
        const customer = Customer.parseFromObject(customerData);
        return customer;
    },
    updateCustomerAction: async (_ctx, payload: { customer: Customer }): Promise<Customer> => {
        const customerData = await customerRepository.updateCustomer(payload.customer);
        const updatedCustomer = Customer.parseFromObject(customerData);
        return updatedCustomer;
    },
    deleteCustomerAction: async (_ctx, payload: { customerId: string }): Promise<Customer> => {
        const customerData = await customerRepository.deleteCustomer(payload.customerId);
        const deletedCustomer = Customer.parseFromObject(customerData);
        return deletedCustomer;
    }
};

const mutations = {
    saveAllCustomers: (state: CustomerState, payload: { customers: Customer[] }) => {
        state.allCustomers = payload.customers;
    }
};

const getters = {
    allCustomers: (state: CustomerState) => {
        return state.allCustomers;
    }
};

const customerStore: Module<any, any> = {
    state: store,
    actions,
    mutations,
    getters
};

export default customerStore;
